export type TransformFormatType = 'text' | 'markdown' | 'json' | 'html' | 'javascript' | 'response';

export type TransformIq = 'low' | 'default' | 'high';

export type ITransformConfig = {
    iq: TransformIq,
    temperature: number,
    maxTokens: number,
}
export interface ITransform {
    header: ITransformHeader,
    rows: ITransformRow[],
    config: ITransformConfig
}

export interface ITransformHeader {
    "input": { "format": TransformFormatType },
    "query": { "format": TransformFormatType },
    "prompt": { "format": Extract<TransformFormatType, 'text'>, "value": string },
    "result": { "format": TransformFormatType }
}


export interface ITransformRow {
    id: string;
    input: string;
    query: string;
    prompt: string;
    result: string;
    editing: boolean;
    deleting: boolean;
    visible?: boolean;
    rowIndex?: number;
    isResultLoading?: boolean;
    isNew?: boolean;
}


export const TRANSFROM_MAX_TOKENS = 16000;
